import { useEffect } from "react";
import { rasterTileRegistry } from "../../apis/RasterTileRegistry"; 

// Rasters go under the labels and under the buildings layer if it's on the map
const getBeforeId = (map) => {
  if (map.getLayer("buildings-layer")) return "buildings-layer";
  return map.getStyle()?.layers?.find((l) => l.type === "symbol")?.id;
};

const useRasterTile = (mapRef, key, show) => {
  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    const config = rasterTileRegistry[key];
    if (!config) {
      console.warn(`useRasterTile: unknown raster layer "${key}"`);
      return;
    }
    const { sourceId, source, layers } = config;

    const add = () => {
      if (!map.style) return;
      if (!map.getSource(sourceId)) map.addSource(sourceId, source);
      const beforeId = getBeforeId(map);
      layers.forEach((layer) => {
        if (!map.getLayer(layer.id)) map.addLayer(layer, beforeId);
      });
    };

    const remove = () => {
      if (!map.style) return; // map already destroyed
      layers.forEach((layer) => {
        if (map.getLayer(layer.id)) map.removeLayer(layer.id);
      });
      if (map.getSource(sourceId)) map.removeSource(sourceId);
    };

    if (!show) {
      remove();
      return;
    }

    // isStyleLoaded() can be false while tiles are still loading, so fall back to "idle"
    if (map.isStyleLoaded()) add();
    else map.once("idle", add);

    // a basemap change wipes custom sources and layers, so re-add them
    map.on("style.load", add);

    return () => {
      map.off("idle", add);
      map.off("style.load", add);
      remove();
    };
  }, [mapRef, key, show]);
};

export default useRasterTile;